<h2 class="hide-for-small-only">Welcome, {{ userInfo?.firstName }}</h2>
<hr class="divider hide-for-small-only">
<app-text [alias]="'main_menu_component'"></app-text>
<div class="row small-up-1 medium-up-3 large-up-4 home-boxes">
   <div *ngIf="userInfo?.ifAnyGranted([roles.siteAdmin]) === true" class="column"><a [routerLink]="'site-admin'" class="add">Site Admin</a></div>
   <div *ngIf="userInfo?.ifAnyGranted([roles.departmentAdministrator]) === true && !userInfo?.ifAnyGranted([roles.registrarStaff, roles.registrarAdmin])" class="column"><a
           [routerLink]="['/home/staff-reports']" class="no-sprite">
      <mat-icon color="primary">list</mat-icon>
      <div>Report</div>
   </a></div>
</div>

<div *ngIf="userInfo?.ifAnyGranted([roles.registrarStaff, roles.registrarAdmin]) === true">
   <app-registrar></app-registrar>
</div>
<div *ngIf="userInfo?.ifAnyGranted([roles.instructor]) === true" class="margin-top-lg">
   <app-instructor></app-instructor>
</div>


